<div class="mx-auto mt-28 sm:mt-40 max-w-screen-2xl">
  <div class="w-10/12 mx-auto sm:w-9/12 pyg-intro">
    <h2 class="max-w-xl">{{ "vq.advantages.title" | translate }}</h2>

    <section class="flex-row-reverse mt-12 lg:flex">
      <div class="relative lg:w-1/2 xl:w-1/3">
        <img
          src="assets/img/VirtualQueue/vg-management.png"
          alt="VQ-Management"
          class="mx-auto"
        />
      </div>

      <div class="lg:w-1/2 xl:w-2/3 xl:flex xl:flex-wrap">
        @for (advantage of advantages; track advantage; let index = $index) {
          <div class="flex pr-6 mt-8 xl:mt-0 xl:w-1/2 h-max-content">
            <div class="numbers">{{ `0${index + 1}` }}</div>
            <div class="vl"></div>
            <p class="pl-4">
              {{ `vq.advantages.advantage${advantage}` | translate }}
            </p>
          </div>
        }
      </div>
    </section>
  </div>
</div>
